import { render, staticRenderFns } from "./radioButton.vue?vue&type=template&id=d572713e&"
import script from "./radioButton.vue?vue&type=script&lang=ts&"
export * from "./radioButton.vue?vue&type=script&lang=ts&"
import style0 from "./radioButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports